import {ApiClient} from '@/api/api.client';
import {
    AUTH_ACCESS_TOKEN_KEY,
    shouldExpireAdminSession,
} from '@/services/admin-session.mjs';

export const API_AUTH_EXPIRED_EVENT = 'nalogika:auth-expired';
let authExpirationHandled = false;

export const api = new ApiClient({
    baseURL: process.env.VUE_APP_API_URL,
    securityWorker: (securityData) => securityData
        ? {headers: {'Authorization': `Bearer ${securityData}`}}
        : {}
});

api.instance.interceptors.response.use(
    response => response,
    error => {
        const authorization = error.config?.headers?.get?.('Authorization')
            || error.config?.headers?.Authorization;
        const storedToken = typeof localStorage !== 'undefined'
            ? localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
            : undefined;
        if (shouldExpireAdminSession({
            status: error.response?.status,
            authorization,
            apiToken: api.securityData,
            storedToken,
            alreadyHandled: authExpirationHandled,
        })) {
            authExpirationHandled = true;
            localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY);
            removeApiAuthToken();
            window.dispatchEvent(new CustomEvent(API_AUTH_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);

export function isApiAuthTokenSet(token) {
    return api.securityData === token
}

export function setApiAuthToken(token) {
    authExpirationHandled = false;
    api.setSecurityData(token);
}

export function removeApiAuthToken() {
    api.setSecurityData(undefined);
}
